import logo_cashd from "../../assets/LoginV2/logo_cashd.svg";

export const AuthHeader2 = () => {
  return (
    <>
      <div className="row text-center mt-14 lg:!mt-auto mb-8">
        <div className="w-full flex items-center justify-center logo">
          <img src={logo_cashd} alt="Logo" height="51px" width="172px"/>
        </div>
      </div>
    </>
  );
};
